import MapLayout from "@/components/Map";
import { ParlorDetailProps } from "@/types/parlor";
import { customEvent } from "goi_common";

interface ParlorInfoGridProps {
  parlor: ParlorDetailProps;
  companyName: string;
  address: string;
  telephone?: string;
  managedType: string;
  binsoCount: number;
}

export const ParlorInfoGrid = ({
  parlor,
  companyName,
  address,
  telephone,
  managedType,
  binsoCount,
}: ParlorInfoGridProps) => {
  const parlorId = parlor.id;
  return (
    <section
      className="pd-section"
      id="pd-info"
      aria-labelledby="pd-info-title"
    >
      <header className="pd-section__head">
        <div className="pd-section__title-block">
          <span className="pd-section__eyebrow">기본 정보</span>
          <h2 id="pd-info-title">{companyName} 한눈에 보기</h2>
          <p className="pd-section__desc">
            {companyName}의 주소, 연락처, 시설 규모와 위치 정보입니다. e하늘
            장사정보시스템 데이터와 현장 확인을 기반으로 합니다.
          </p>
        </div>
      </header>

      <div className="pd-info-grid">
        <article className="pd-info-card">
          <span className="pd-info-card__label">주소</span>
          <span className="pd-info-card__value">{address}</span>
          <a
            className="pd-info-card__link"
            href={`/directions/${parlorId}/`}
            onClick={() =>
              customEvent({
                newGtm: {
                  path: "prlr_fam_main",
                  trigger_and_target: "btn_to_directions",
                },
              })
            }
          >
            오시는 길 자세히 보기 →
          </a>
        </article>
        <article className="pd-info-card pd-info-card--tel">
          <span className="pd-info-card__label">전화번호</span>
          <span className="pd-info-card__value">
            {telephone ? (
              <a href={`tel:${telephone}`}>{telephone}</a>
            ) : (
              "정보 없음"
            )}
          </span>
          <span className="pd-info-card__hint">
            장례식장 직통 · 24시간 운영
          </span>
        </article>
        <article className="pd-info-card">
          <span className="pd-info-card__label">시설 형태</span>
          <span className="pd-info-card__value">{managedType} 장례식장</span>
        </article>
        <article className="pd-info-card">
          <span className="pd-info-card__label">규모</span>
          <span className="pd-info-card__value">
            {binsoCount > 0 ? `빈소 ${binsoCount}실` : "빈소 정보 없음"}
          </span>
        </article>
      </div>

      <div className="pd-map-wrap">
        <MapLayout parlor={parlor} height="320px" />
      </div>
    </section>
  );
};
